import { render, staticRenderFns } from "./ViewTranslationsModal.vue?vue&type=template&id=0258de72"
import script from "./ViewTranslationsModal.vue?vue&type=script&lang=js"
export * from "./ViewTranslationsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports